module.exports = __webpack_public_path__ + "static/media/Signature-Image.c782e277.png";